import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const alertVariants = cva('grid grid-cols-[auto_1fr] items-start gap-x-4 gap-y-1 rounded-lg p-4', {
  variants: {
    variant: {
      info: 'bg-secondary-50',
      error: 'bg-warning-100',
    },
  },
});

const iconVariants = cva('inline-flex size-10 items-center justify-center rounded-full [&>svg]:size-5', {
  variants: {
    variant: {
      info: 'bg-secondary-brand text-black',
      error: 'bg-warning-700 text-white',
    },
  },
});

function PageAlert({ variant, className, ...props }: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div role="alert" className={cn(alertVariants({ variant }), className)} {...props} />;
}

function PageAlertIcon({
  variant,
  className,
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof iconVariants>) {
  return <span className={cn('row-span-2', iconVariants({ variant }), className)} aria-hidden="true" {...props} />;
}

function PageAlertTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('col-start-2 text-base font-bold', className)} {...props} />;
}

function PageAlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('col-start-2 text-sm', className)} {...props} />;
}

export { PageAlert, PageAlertIcon, PageAlertTitle, PageAlertDescription };
